/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToRem } from '@insticator/insticator-ui'; // iui-utils

/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION : STYLES --------------- ++++++++++ */
export default theme => ({
  sectiongroupdescription: {
    '& > h4': {
      marginTop: pxToRem(8)
    },
    '& > h2': {
      marginBottom: pxToRem(16),
      '& i': {
        position: 'relative',
        top: pxToRem(1),
        color: 'rgb(130, 149, 186)'
      },
      '& .link': {
        marginLeft: pxToRem(10)
      }
    }
  }
});
